import { render, staticRenderFns } from "./QuestionTextWithAutocomplete.vue?vue&type=template&id=3b9403d2&scoped=true"
import script from "./QuestionTextWithAutocomplete.vue?vue&type=script&lang=js"
export * from "./QuestionTextWithAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./QuestionTextWithAutocomplete.vue?vue&type=style&index=0&id=3b9403d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9403d2",
  null
  
)

export default component.exports